var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":"https://wa.me/+393297966921","target":"_blank"}},[_c('img',{attrs:{"src":require('/src/assets/img/wa.png'),"alt":"Contattaci tramite WhatsApp"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }